import { motion } from "framer-motion";

const stats = [
    {
        number: "+50",
        label: "Proyectos realizados"
    },
    {
        number: "+30",
        label: "Clientes atendidos"
    },
    {
        number: "+120",
        label: "Planos elaborados"
    },
    {
        number: "+5",
        label: "Años de experiencia"
    }
];

const Stats = () => {
    return (
        <section className="py-24 bg-[#1C1C1C] text-white">

            <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-4 gap-12 text-center">

                {stats.map((stat, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: index * 0.2 }}
                        viewport={{ once: true }}
                    >

                        <h3 className="text-4xl md:text-5xl font-bold text-[#F26B1D]">
                            {stat.number}
                        </h3>

                        <p className="mt-4 text-gray-300">
                            {stat.label}
                        </p>

                    </motion.div>
                ))}

            </div>

        </section>
    );
};

export default Stats;